import React from 'react';
import ProcessLoader from './animation/ProcessLoader';

const UploadProcessingWithAnimationComponent = ({ title, message }) => {
    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full pt-[10px]">
                <div>
                    <div>
                        <div className="text-h5 font-bold mb-2 text-flow-heading">{title}</div>
                        <div className="text-body text-Gray900">
                            {message}
                        </div>
                    </div>
                    <ProcessLoader />
                </div>
            </div>
        </div>
    );
};

export default UploadProcessingWithAnimationComponent;